import { h } from 'preact';

export const CookieIcon: h.JSX.Element = (
  <div class="cc-icon-cookie ccm-col">
    <em>
      <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.988.017a.824.824 0 01.992.808 2.653 2.653 0 002.653 2.653c.405 0 .804-.097 1.166-.282a1.02 1.02 0 011.376.453A2.633 2.633 0 0016.53 5.11c.37 0 .734-.08 1.072-.237a1.02 1.02 0 011.334.469A9.879 9.879 0 0120 9.803 10 10 0 117.988.017zm-.2 1.304l-.049.012a8.775 8.775 0 1011.037 8.47c0-1.357-.32-2.697-.933-3.91l.081.172-.026.012c-.29.113-.593.19-.901.228l-.233.022-.234.008a3.858 3.858 0 01-3.246-1.778l-.11-.186-.05.024c-.391.169-.81.27-1.235.299l-.256.008A3.878 3.878 0 017.8 1.415l-.012-.094zm4.661 13.38l.103.007a.816.816 0 11-.205 0l.102-.006zm-4.897-3.06a2.245 2.245 0 110 4.49 2.245 2.245 0 010-4.49zm0 1.224a1.02 1.02 0 100 2.04 1.02 1.02 0 000-2.04zm4.897-2.857a1.429 1.429 0 110 2.857 1.429 1.429 0 010-2.857zm0 1.224a.204.204 0 100 .409.204.204 0 000-.409zM3.47 9.804l.103.006a.816.816 0 11-.205 0l.102-.006zM6.735 5.11a2.245 2.245 0 110 4.49 2.245 2.245 0 010-4.49zm6.53 2.245l.103.006a.816.816 0 11-.205 0l.103-.006zm-6.53-1.02a1.02 1.02 0 100 2.04 1.02 1.02 0 000-2.04z"
          fill="#222222"
          fill-rule="evenodd"
        />
      </svg>
    </em>
  </div>
);
